import * as Dialog from '@radix-ui/react-dialog'

type OverrideFileDialogProps = {
  open: boolean
  fileName: string
  onOverride: () => void
  onRename: () => void
  onClose: () => void
}

export function OverrideFileDialog({ open, fileName, onOverride, onRename, onClose }: OverrideFileDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-black/50 fixed inset-0 z-[1000]" />
        <Dialog.Content className="fixed top-1/2 left-1/2 w-[90vw] max-w-[480px] -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-lg focus:outline-none z-[1000] overflow-hidden">
          <Dialog.Title className="text-xl font-semibold px-6 pt-6 pb-2">File Already Exists</Dialog.Title>

          <div className="px-6 pb-6">
            <p className="text-brand-neutral-700 mb-4">
              A file named <strong>{fileName}</strong> already exists in this location.
            </p>
            <p className="text-brand-neutral-600 text-sm">Would you like to override the existing file or rename your file?</p>
          </div>

          <div className="flex justify-end gap-3 px-6 pb-6 pt-4">
            <button
              onClick={onRename}
              className="px-4 py-2 rounded-md outline outline-1 outline-offset-[-1px] outline-brand-neutral-950 inline-flex justify-center items-center gap-1 overflow-hidden text-sm font-medium text-brand-neutral-950 bg-white hover:bg-brand-neutral-100"
              aria-label="Close dialog and rename file"
            >
              Rename
            </button>
            <button
              onClick={onOverride}
              className="px-4 py-2 text-sm font-medium text-white bg-brand-500 border border-transparent rounded-md hover:bg-brand-600"
              aria-label={`Override existing file ${fileName}`}
            >
              Override
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
